import { Flex } from 'antd'
import { UiText } from 'src/pages/budget/components'

type Props = {
  items: {
    country: string
    amountCountry: string
  }[]
  total: string
}
export const CostDescription = ({ items, total }: Props) => {
  return (
    <Flex vertical gap={8} style={{ width: '80%', fontSize: 18 }}>
      {items.map((item, index) => (
        <Flex key={index} justify="flex-start">
          <UiText size={18} style={{ width: 280 }}>
            {item.country}
          </UiText>
          <UiText size={18} style={{ flex: 1 }}>
            {item.amountCountry}
          </UiText>
        </Flex>
      ))}

      <Flex justify="space-between">
        <UiText size={18} strong style={{ width: 280 }}>
          Итого
        </UiText>
        <UiText size={18} strong style={{ flex: 1 }}>
          {total}
        </UiText>
      </Flex>
    </Flex>
  )
}
